/* Handles the Google OAuth redirect with #session_id=... in the URL.
   Renders synchronously when fragment is present (race-condition safe).
   REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
*/
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Loader2, AlertCircle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const [status, setStatus] = useState("processing"); // processing | error
  const [errMsg, setErrMsg] = useState("");
  const { refreshUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      setStatus("error");
      setErrMsg("Missing session_id in URL");
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        await axios.post(
          `${API}/auth/google-callback`,
          { session_id },
          { withCredentials: true }
        );
        await refreshUser();
        // Clear hash and redirect to /profile (or wherever they came from)
        window.location.replace("/profile");
      } catch (e) {
        setStatus("error");
        setErrMsg(
          e?.response?.data?.detail ||
            e?.message ||
            "Google sign-in failed."
        );
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center p-6">
      <div className="bg-[#0F0F0F] border-2 border-[#D4AF37] p-8 max-w-md w-full text-center">
        {status === "processing" ? (
          <>
            <Loader2 size={40} className="animate-spin text-[#D4AF37] mx-auto mb-4" />
            <h2 className="font-display text-2xl text-white mb-1">Signing you in…</h2>
            <p className="text-neutral-400 text-sm">🌈 Welcome to OmniMuscle.</p>
          </>
        ) : (
          <>
            <AlertCircle size={40} className="text-[#DC2626] mx-auto mb-4" />
            <h2 className="font-display text-2xl text-white mb-2">Sign-in failed</h2>
            <p className="text-neutral-400 text-sm mb-5">{errMsg}</p>
            <button
              onClick={() => (window.location.href = "/")}
              className="btn-omni btn-outline-gold"
            >
              Back to OMNIMUSCLE
            </button>
          </>
        )}
      </div>
    </div>
  );
}
